module.exports = __webpack_public_path__ + "media/images/icon/notification-icon-91c229ec7bb24bb3b924a0f53a71a277.svg";